import { create } from 'zustand'
import axios from 'axios'
import { cleanParamsFilter } from 'Utils/cleanParamsFilter'

import { CRUDBaseStore } from './Base/CRUD'

interface SaleOrderStore extends CRUDBaseStore {
  totalData: number
  selectedId: any
  items: any[]
  versions: any[]
  setTotalData: (totalData: number) => void
  setSelectedId: (selectedId: any) => void
  setVersions: (versions: any[]) => void
  setItems: (items: any[]) => void
  getAllPagination: (filter: any) => Promise<{ success: boolean; data: any }>
  getOne: (id: number) => Promise<{ success: boolean; data: any }>
  duplicate: (id: number) => Promise<{ success: boolean; data: any }>
  getItems: (id: number) => Promise<{ success: boolean; data: any }>
  upsertItems: (id: number, data: any) => Promise<{ success: boolean; data: any }>
}

export const API_SLUG = 'saleOrder'

export const INITIAL_STATE = {
  id: 0,
  code: '',
  division: '',
  customerId: 0,
  customerTitle: '',
  customerEmail: '',
  saleTitle: '',
  //'2023-08-30T00:00:00'
  deliveryDocumentDate: null,
  //'2023-08-30T00:00:00'
  startJobDate: null,
  //'2023-08-30T00:00:00'
  endJobDate: null,
  totalDate: 0,
  address: '',
  provinceId: 0,
  districtId: 0,
  subDistrictId: 0,
  postCode: '',
  jobStatus: '',
  note: '',
  //'2023-08-30T00:00:00'
  createdAt: null,
  //'2023-08-30T00:00:00'
  updatedAt: null,
  // createdByUserId: '',
  // createdByUser: {
  //   id: '',
  //   username: '',
  //   fullName: '',
  //   position: null,
  //   permissions: null,
  //   permissionUsers: [],
  //   mobile: null,
  //   isActive: true,
  //   createdAt: null,
  //   verifyAt: null,
  //   lastLoginAt: null,
  // },
  saleOrderDocuments: [],
  saleOrderItems: [
    // {
    //   id: 1,
    //   itemCode: '12',
    //   itemTitle: 'Test',
    //   quantity: 50,
    //   createdAt: '2023-08-31T19:39:53.1781053',
    //   updatedAt: '2023-08-31T19:39:53.1781062',
    //   saleOrderId: 3,
    //   saleOrder: null,
    // },
  ],
}

export const useSaleOrderStore = create<SaleOrderStore>(set => ({
  data: [],
  selected: INITIAL_STATE,
  selectedId: undefined,
  versions: [],
  items: [],
  totalData: 0,
  loading: false,
  error: undefined,
  setTotalData: (totalData: number) => {
    set({ totalData })
  },
  setLoading: (loading: boolean) => {
    set({ loading })
  },
  setError: (error: any) => {
    set({ error })
  },
  setSelected: (selected: any) => {
    set({ selected })
  },
  setSelectedId: (selectedId: any) => {
    set({ selectedId })
  },
  setVersions: (versions: any[]) => {
    set({ versions })
  },
  setItems: (items: any[]) => {
    set({ items })
  },
  getAll: async (filter: any) => {
    set({ loading: true })
    const finaleFilter = cleanParamsFilter(filter)

    return axios
      .get(`/${API_SLUG}`, { params: finaleFilter })
      .then(res => {
        set({ data: res.data })
        set({ loading: false })

        return { success: true, data: res.data }
      })
      .catch(err => {
        set({ loading: false })
        set({ error: err?.response?.data?.message?.toString() })
        return { success: false, data: err?.response?.data?.message?.toString() }
      })
  },
  getAllPagination: async (filter: any) => {
    set({ loading: true })
    const finaleFilter = cleanParamsFilter(filter)

    return axios
      .get(`/${API_SLUG}/pagination`, { params: finaleFilter })
      .then(res => {
        const { totalCount, data } = res.data
        set({ data, totalData: totalCount })
        set({ loading: false })

        return { success: true, data: res.data }
      })
      .catch(err => {
        set({ loading: false })
        set({ error: err?.response?.data?.message?.toString() })
        return { success: false, data: err?.response?.data?.message?.toString() }
      })
  },
  getOne: async id => {
    set({ loading: true })

    return axios
      .get(`/${API_SLUG}/${id}`)
      .then(res => {
        set({ selected: res.data.saleOrder, versions: res.data.versions })
        set({ loading: false })

        return { success: true, data: res.data }
      })
      .catch(err => {
        set({ loading: false })
        set({ error: err?.response?.data?.message?.toString() })
        return { success: false, data: err?.response?.data?.message?.toString() }
      })
  },
  getItems: async id => {
    set({ loading: true })

    return axios
      .get(`/${API_SLUG}/${id}/item-shipment`)
      .then(res => {
        set({ items: res.data })
        set({ loading: false })

        return { success: true, data: res.data }
      })
      .catch(err => {
        set({ loading: false })
        set({ error: err?.response?.data?.message?.toString() })
        return { success: false, data: err?.response?.data?.message?.toString() }
      })
  },
  create: async (data: any) => {
    set({ loading: true })

    const formData = new FormData()
    Object.keys(data).forEach(key => {
      if (data[key] !== undefined) {
        formData.append(key, data[key])
      }
    })

    return axios
      .post(`/${API_SLUG}`, formData)
      .then(res => {
        set({ loading: false })
        return { success: true, data: res.data }
      })
      .catch(err => {
        set({ loading: false })
        set({ error: err?.response?.data?.message?.toString() })
        return { success: false, data: err?.response?.data?.message?.toString() }
      })
  },
  edit: async (id, data) => {
    set({ loading: true })

    const formData = new FormData()
    Object.keys(data).forEach(key => {
      if (data[key] !== undefined && data[key] !== null && data[key] !== 'null') {
        formData.append(key, data[key])
      }
    })

    return axios
      .patch(`/${API_SLUG}/${id}`, formData)
      .then(res => {
        set({ loading: false })
        return { success: true, data: res.data }
      })
      .catch(err => {
        set({ loading: false })
        set({ error: err?.response?.data?.message?.toString() })
        return { success: false, data: err?.response?.data?.message?.toString() }
      })
  },
  upsertItems: async (id : number, data : any) => {
    set({ loading: true })

    const formData = new FormData()
    Object.keys(data).forEach(key => {
      if (data[key] !== undefined && data[key] !== null && data[key] !== 'null') {
        formData.append(key, data[key])
      }
    })

    return axios
      .put(`/${API_SLUG}/${id}/items`, formData)
      .then(res => {
        set({ loading: false })
        return { success: true, data: res.data }
      })
      .catch(err => {
        set({ loading: false })
        set({ error: err?.response?.data?.message?.toString() })
        return { success: false, data: err?.response?.data?.message?.toString() }
      })
  },
  duplicate: async (id : number) => {
    set({ loading: true })

    return axios
      .post(`/${API_SLUG}/${id}/new-version`)
      .then(res => {
        set({ loading: false })
        return { success: true, data: res.data }
      })
      .catch(err => {
        set({ loading: false })
        set({ error: err?.response?.data?.message?.toString() })
        return { success: false, data: err?.response?.data?.message?.toString() }
      })
  },

  delete: async id => {
    set({ loading: true })
    return axios
      .delete(`/${API_SLUG}/${id}`)
      .then(res => {
        set({ loading: false })
        return { success: true, data: res.data }
      })
      .catch(err => {
        set({ loading: false })
        set({ error: err?.response?.data?.message?.toString() })
        return { success: false, data: err?.response?.data?.message?.toString() }
      })
  },
  clearState: () => {
    set({
      data: [],
      totalData: 0,
      loading: false,
      error: undefined,
      selected: INITIAL_STATE,
    })
  },
}))
